export enum StatusTicketCard {
    ACTIVE = 'ticket_active',
    CANCELLED = 'ticket_cancelled',
    INACTIVE = 'ticket_inactive'
}